/**
 * @generated SignedSource<<0381b8573e0a21ccd16fa9602db0c96c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Order_paymentLink$data = {
  readonly " $fragmentSpreads": FragmentRefs<"Payment_paymentLink">;
  readonly " $fragmentType": "Order_paymentLink";
};
export type Order_paymentLink$key = {
  readonly " $data"?: Order_paymentLink$data;
  readonly " $fragmentSpreads": FragmentRefs<"Order_paymentLink">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Order_paymentLink",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Payment_paymentLink"
    }
  ],
  "type": "PaymentLink",
  "abstractKey": null
};

(node as any).hash = "215ef465e42bcb4b8aaa0fc53d2ed4b9";

export default node;
